import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step18 from './Step18-redux';

export default compose(
  withRouter,
  withNextStep
)(Step18);
